<div class="download-list-container">
    <div class="custom-container">
        <mat-card class="download-card">
            <mat-card-content>
                <h1>Centro de Descargas</h1>
                <downloads-table 
                                [columnHeader]="columnHeader" 
                                [filterOptions]="filterOptions"
                                [catalogPaginationRequest]="catalogPaginationRequest">
                </downloads-table>
            </mat-card-content>
        </mat-card>
    </div>
</div>